var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-gray-200 flex items-center" },
    _vm._l(_vm.tabs, function (tab) {
      return _c(
        "button",
        {
          key: tab.value,
          staticClass: "p-2 flex-1 leading-6",
          class: {
            "bg-white text-blue-400": _vm.value === tab.value,
          },
          on: {
            click: function ($event) {
              return _vm.onClick(tab)
            },
          },
        },
        [_vm._v(_vm._s(tab.label))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }